// components/Tag/Tag.tsx
import React from "react";

interface TagProps {
  children: React.ReactNode;
}

const Tag: React.FC<TagProps> = ({ children }) => {
  return (
    <div className="absolute top-2 left-2 bg-primary text-white text-xs font-semibold px-2 py-1 rounded flex items-center gap-1">
      {children}
    </div>
  );
};

export default Tag;
